import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-chevron-more-icon',
  templateUrl: './lib-chevron-more-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibChevronMoreIconComponent {}
